module.exports = __webpack_public_path__ + "static/media/17UN-Women5.7fa54afb.jpg";